import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Table, Typography, notification, Tag } from 'antd';
import { useEffect, useState } from 'react';
import apiService from '../../services/api-service';
import { WorkPolicy } from 'src/types/common.types';
import useWorkPolicies from 'src/hooks/use-work-policies';

type WorkerPageProps = {
  apiUrl?: string;
  title?: string;
};

type Worker = {
  id?: number;
  name: string;
  address: string;
  phone: string;
  active: number;
  workPolicyId: number;
  workerPolicy?: any;
};

export default function WorkerPage(props: WorkerPageProps) {
  const apiUrl = '/api/workers';
  const [data, setData] = useState<Worker[]>([]);
  const [currentEditItem, setCurrentEditItem] = useState<Worker>();
  const [isCreateNewItem, setIsCreateNewItem] = useState(false);
  const [form] = Form.useForm();
  const { data: workPolicies, error: errorWorkPolicies, isLoading: isLoadingWorkPolicies } = useWorkPolicies();
  async function getAllData() {
    try {
      const response = await apiService.get<Worker[]>(apiUrl, {
        params: {
          includeWorkerPolicy: true,
        },
      });
      const sources = response.data;
      if (response.status != 200) {
        throw new Error();
      }
      setData(
        sources.map((source: Worker) => ({
          ...source,
          workPolicyId: source.workerPolicy?.workPolicyId,
        })),
      );
    } catch (error: any) {
      notification.error({ message: 'Lỗi tải dữ liệu' });
      console.error(error?.message);
    }
  }
  const onEditItem = (item: Worker) => {
    setCurrentEditItem(item);
    form.setFieldsValue(item);
  };
  const onPressCreateNewItem = () => {
    setIsCreateNewItem(true);
  };

  const onCreateNewItem = async () => {
    try {
      const submitData = form.getFieldsValue();
      const response = await apiService.post(apiUrl, submitData);
      if (response.status == 200) {
        notification.success({ message: 'Thêm thành công' });
      }
      form.resetFields();
      setIsCreateNewItem(false);
    } catch (error: any) {
      notification.error({ message: 'Lỗi thêm mới' });
      console.error(error?.message);
    }
  };

  const onUpdateItem = async () => {
    try {
      const submitData: Worker = form.getFieldsValue();
      submitData.id = currentEditItem!!.id;
      const response = await apiService.put(`${apiUrl}/${currentEditItem!!.id}`, submitData);
      if (response.status == 200) {
        notification.success({ message: 'Cập nhật thành công' });
      }
      onCloseModal();
      getAllData();
    } catch (error: any) {
      notification.error({ message: 'Lỗi thêm mới' });
      console.error(error?.message);
    }
  };

  const onCloseModal = () => {
    setCurrentEditItem(undefined);
    setIsCreateNewItem(false);
    form.resetFields();
  };
  useEffect(() => {
    getAllData();
  }, []);

  return (
    <div className="p-[24px]">
      <Typography.Title level={4}>{props.title || 'Thợ/kỹ thuật viên'}</Typography.Title>
      <div className="mb-[16px]">
        <Button size="large" onClick={onPressCreateNewItem} type="primary">
          Tạo mới
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            dataSource={data}
            columns={[
              {
                title: '#ID',
                key: 'id',
                dataIndex: 'id',
              },
              {
                title: 'Name',
                key: 'name',
                dataIndex: 'name',
              },
              {
                title: 'Địa chỉ',
                key: 'address',
                dataIndex: 'address',
              },
              {
                title: 'Số điện thoại',
                key: 'phone',
                dataIndex: 'phone',
              },
              {
                title: 'Chính sách công',
                key: 'workPolicy',
                render: (record: Worker) => {
                  return <Tag color="blue">{record.workerPolicy?.workPolicy?.name}</Tag>;
                },
              },
              {
                title: 'Trạng thái',
                key: 'active',
                dataIndex: 'active',
                render: (active: boolean) => {
                  let text = 'Không hoạt động';
                  switch (active) {
                    case true:
                      text = 'Hoạt động';
                      break;
                    default:
                      break;
                  }
                  return <Tag color={active ? 'green' : 'red'}>{text}</Tag>;
                },
              },
              {
                title: '',
                render: record => {
                  return <></>;
                },
              },
            ]}
            onRow={(record, rowIndex) => {
              return {
                onClick: e => onEditItem(record),
              };
            }}
          />
        </Col>
      </Row>
      <Modal
        open={!!currentEditItem || isCreateNewItem}
        destroyOnClose={true}
        cancelText="Hủy"
        okText={isCreateNewItem ? 'Lưu' : 'Cập nhật'}
        title={isCreateNewItem ? 'Tạo mới' : 'Cập nhật'}
        onCancel={() => onCloseModal()}
        onOk={isCreateNewItem ? onCreateNewItem : onUpdateItem}
        width={'50vw'}
      >
        <div className="p-2">
          <Form form={form} wrapperCol={{ span: 18 }} labelCol={{ span: 6 }}>
            <Form.Item label="Tên" name="name">
              <Input disabled />
            </Form.Item>
            <Form.Item label="Địa chỉ" name="address">
              <Input disabled />
            </Form.Item>
            <Form.Item label="Số điện thoại" name="phone">
              <Input className="w-full" disabled />
            </Form.Item>
            <Form.Item label="Trạng thái" name="active">
              <Select
                options={[
                  {
                    label: 'Hoạt động',
                    value: true,
                  },
                  {
                    label: 'Không hoạt động',
                    value: false,
                  },
                ]}
                disabled
              />
            </Form.Item>
            <Form.Item label="Chính sách công" name="workPolicyId">
              <Select
                options={workPolicies?.map((workPolicy: WorkPolicy) => ({
                  label: workPolicy.name,
                  value: workPolicy.id,
                }))}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
}
